module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-open-innovation.718fa9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-open-innovation.jpg
// module id = H71+
// module chunks = 0